import React from 'react';
import { useNavigate } from 'react-router-dom';
import './LandingPage.css';

const HandleidingTherapeut = () => {
  const navigate = useNavigate();

  const goBack = () => {
    navigate('/');
  };

  return (
    <div>
      {/* Navigation */}
      <nav className="nav">
        <div className="nav-container">
          <div className="logo" onClick={goBack}>GezinsScan</div>
          
          <div className="nav-links">
            <span className="nav-brand">by <strong>PABB</strong></span>
          </div>
        </div>
      </nav>

      {/* Main Content */}
      <section className="section" style={{paddingTop: '120px'}}>
        <div className="container">
          <div style={{maxWidth: '800px', margin: '0 auto'}}>
            
            {/* Header */}
            <div style={{textAlign: 'center', marginBottom: '3rem'}}>
              <h1 className="hero-title" style={{fontSize: '2.5rem', marginBottom: '1rem'}}>
                Handleiding voor Therapeuten
              </h1>
              <p className="hero-subtitle" style={{fontSize: '1.2rem', color: '#64748b'}}>
                Stap-voor-stap gids voor het uitvoeren van GezinsScans
              </p>
            </div>

            {/* Intro */}
            <div className="benefit-card" style={{marginBottom: '2rem', borderLeft: '4px solid #3b82f6'}}>
              <h2 className="card-title">Wat is de GezinsScan?</h2>
              <p className="card-description">
                De GezinsScan is een professionele relatie assessment tool gebaseerd op Patrick Lencioni's "De 5 Frustraties van Teamwork", aangepast voor relatietherapie. 
                Het helpt de therapeut of coach om een eerste inzicht te krijgen waar gezinnen staan op de piramide van Lencioni. De piramide bevat 5 kritieke gebieden: 
                Vertrouwen, Conflicten, Commitment, Verantwoording en Gezamenlijk belang.
              </p>
              
              <h3 style={{marginTop: '1.5rem', marginBottom: '1rem', color: '#1e3a8a'}}>Hoe werkt het?</h3>
              <ul style={{color: '#64748b', lineHeight: '1.8'}}>
                <li><strong>Therapeut of coach</strong> maakt een relatie aan en nodigt deelnemers uit</li>
                <li><strong>Deelnemers</strong> vullen individueel een vragenlijst in (25 vragen, ~15 minuten)</li>
                <li><strong>GezinsScan</strong> analyseert de resultaten en toont waar het gezin kan verbeteren</li>
                <li><strong>Therapeutof coach</strong> bespreekt de resultaten met de deelnemers</li>
              </ul>
            </div>

            {/* 1. Account Aanmaken */}
            <div className="benefit-card" style={{marginBottom: '2rem'}}>
              <h2 className="card-title">1. Account Aanmaken</h2>
              
              <h3 style={{color: '#1e3a8a', marginBottom: '1rem'}}>Stap 1: Registreren</h3>
              <ol style={{color: '#64748b', lineHeight: '1.8', marginBottom: '1.5rem'}}>
                <li>Ga naar <a href="https://gezinsscan.pabb.nl" style={{color: '#3b82f6'}}>https://gezinsscan.pabb.nl</a></li>
                <li>Klik op <strong>"Start GezinsScan"</strong></li>
                <li>Vul je gegevens in:
                  <ul style={{marginTop: '0.5rem'}}>
                    <li><strong>Naam:</strong> Je volledige naam</li>
                    <li><strong>Email:</strong> Je email adres</li>
                    <li><strong>Wachtwoord:</strong> Minimaal 12 karakters met hoofdletter, cijfer en speciaal teken</li>
                  </ul>
                </li>
                <li>Klik <strong>"Account Aanmaken"</strong></li>
              </ol>

              <h3 style={{color: '#1e3a8a', marginBottom: '1rem'}}>Stap 2: Email Verificatie</h3>
              <ol style={{color: '#64748b', lineHeight: '1.8', marginBottom: '1.5rem'}}>
                <li>Check je email voor een verificatiebericht</li>
                <li>Klik op de verificatielink in de email</li>
                <li>Je account is nu actief</li>
              </ol>

              <h3 style={{color: '#1e3a8a', marginBottom: '1rem'}}>Stap 3: Pakket Aanvragen</h3>
              <div style={{background: '#fef3c7', padding: '1rem', borderRadius: '8px', marginBottom: '1rem'}}>
                <p style={{margin: '0', color: '#92400e', fontWeight: '600'}}>
                  <strong>Let op:</strong> Momenteel worden scans handmatig toegekend.
                </p>
              </div>
              <ol style={{color: '#64748b', lineHeight: '1.8'}}>
                <li>Stuur een email naar <strong>diederik@tractum.nl</strong></li>
                <li>Vermeld:
                  <ul style={{marginTop: '0.5rem'}}>
                    <li>Je naam en praktijk</li>
                    <li>Hoeveel GezinsScans je nodig hebt</li>
                    <li>Eventuele vragen over GezinsScan</li>
                  </ul>
                </li>
                <li>Je pakket wordt binnen 1-2 werkdagen geactiveerd</li>
              </ol>
            </div>

            {/* 2. Eerste GezinsScan */}
            <div className="benefit-card" style={{marginBottom: '2rem'}}>
              <h2 className="card-title">2. Eerste GezinsScan Starten</h2>
              
              <h3 style={{color: '#1e3a8a', marginBottom: '1rem'}}>Stap 1: Inloggen</h3>
              <ol style={{color: '#64748b', lineHeight: '1.8', marginBottom: '1.5rem'}}>
                <li>Ga naar <a href="https://gezinsscan.pabb.nl" style={{color: '#3b82f6'}}>https://gezinsscan.pabb.nl</a></li>
                <li>Klik <strong>"Inloggen"</strong></li>
                <li>Vul je email en wachtwoord in</li>
                <li>Je komt automatisch op je dashboard terecht</li>
              </ol>

              <h3 style={{color: '#1e3a8a', marginBottom: '1rem'}}>Stap 2: Relatie Aanmaken</h3>
              <ol style={{color: '#64748b', lineHeight: '1.8', marginBottom: '1.5rem'}}>
                <li>Klik op <strong>"Nieuw Gezin Aanmaken"</strong></li>
                <li><strong>Stap 1 - Gezins Info:</strong>
                  <ul style={{marginTop: '0.5rem'}}>
                    <li><strong>Relatie naam:</strong> Bijvoorbeeld "De Vries Maart 2025"</li>
                    <li><strong>Beschrijving:</strong> Kort doel of context van de scan</li>
                  </ul>
                </li>
                <li><strong>Stap 2 - Cliënten:</strong>
                  <ul style={{marginTop: '0.5rem'}}>
                    <li>Voeg naam en email adressen toe van de deelnemers</li>
                    <li>Klik <strong>"+ Cliënt Toevoegen"</strong> voor meer deelnemers</li>
                    <li>Minimaal 2 deelnemers en maximaal 15 deelnemers</li>
                  </ul>
                </li>
                <li><strong>Stap 3 - Bevestigen:</strong>
                  <ul style={{marginTop: '0.5rem'}}>
                    <li>Controleer alle gegevens</li>
                    <li>Klik <strong>"Gezin Aanmaken en Uitnodigingen Versturen"</strong></li>
                  </ul>
                </li>
              </ol>

              <h3 style={{color: '#1e3a8a', marginBottom: '1rem'}}>Stap 3: Uitnodigingen Versturen</h3>
              <ul style={{color: '#64748b', lineHeight: '1.8'}}>
                <li>GezinsScan verstuurt automatisch uitnodigingsmails naar alle deelnemers</li>
                <li>Elke deelnemer krijgt een unieke code die maar één keer gebruikt kan worden</li>
                <li>De e-mails komen van <strong>noreply@pabb.nl</strong></li>
              </ul>
            </div>

            {/* 3. Voortgang Volgen */}
            <div className="benefit-card" style={{marginBottom: '2rem'}}>
              <h2 className="card-title">3. Voortgang Volgen</h2>
              
              <h3 style={{color: '#1e3a8a', marginBottom: '1rem'}}>Dashboard Bekijken</h3>
              <ol style={{color: '#64748b', lineHeight: '1.8', marginBottom: '1.5rem'}}>
                <li>Log in op je account</li>
                <li>Je ziet een overzicht van al je gezinnen</li>
                <li>Je ziet of alle deelnemers de GezinsScan al ingevuld hebben</li>
                <li>Klik op een gezin en je komt op je <strong>Gezins Dashboard</strong></li>
              </ol>

              <h3 style={{color: '#1e3a8a', marginBottom: '1rem'}}>Gezins Dashboard</h3>
              
              <h4 style={{color: '#059669', marginBottom: '0.5rem'}}>Live Updates</h4>
              <ul style={{color: '#64748b', lineHeight: '1.8', marginBottom: '1.5rem'}}>
                <li>Het gezinsdashboard toont real-time hoeveel deelnemers de vragenlijst hebben voltooid</li>
                <li>Je kunt hier ook een uitnodigingsmail opnieuw verzenden als hij niet aangekomen is</li>
              </ul>

              <h4 style={{color: '#059669', marginBottom: '0.5rem'}}>Resultaten bekijken</h4>
              <p style={{color: '#64748b', marginBottom: '1rem'}}>Je ziet:</p>
              <ul style={{color: '#64748b', lineHeight: '1.8', marginBottom: '1.5rem'}}>
                <li><strong>Voortgang:</strong> Hoeveel deelnemers hebben deelgenomen</li>
                <li><strong>Relatie Scores:</strong> Gemiddelde per trede (Vertrouwen, Conflicten, etc.)</li>
                <li><strong>Focus Gebied:</strong> De trede die het meeste aandacht nodig heeft</li>
                <li><strong>Individuele Scores:</strong> Scores per deelnemer zichtbaar voor therapeut</li>
              </ul>

              <h4 style={{color: '#059669', marginBottom: '0.5rem'}}>Score Uitleg</h4>
              <ul style={{color: '#64748b', lineHeight: '1.8', marginBottom: '1.5rem'}}>
                <li><strong style={{color: '#059669'}}>Groen (4.0+):</strong> Sterk gebied, relatie functioneert goed</li>
                <li><strong style={{color: '#f59e0b'}}>Geel (3.5-4.0):</strong> Voldoende, met ruimte voor verbetering</li>
                <li><strong style={{color: '#ef4444'}}>Rood (&lt;3.5):</strong> Aandachtsgebied, hier ligt de focus</li>
              </ul>

              <div style={{background: '#dbeafe', padding: '1rem', borderRadius: '8px'}}>
                <h4 style={{color: '#1e40af', margin: '0 0 0.5rem 0'}}>Lencioni Principe</h4>
                <p style={{margin: '0', color: '#1e40af'}}>
                  De GezinsScan bepaalt de focus door te kijken welke tredes aandacht nodig hebben (onder 3.5). 
                  Daarna wordt de laagste daarvan in de piramide gekozen, omdat je eerst de basis moet versterken.
                </p>
              </div>
            </div>

            {/* 4. Rapporten */}
            <div className="benefit-card" style={{marginBottom: '2rem'}}>
              <h2 className="card-title">4. Rapport Downloaden</h2>
              
              <h3 style={{color: '#1e3a8a', marginBottom: '1rem'}}>PDF Rapport</h3>
              <ol style={{color: '#64748b', lineHeight: '1.8', marginBottom: '1.5rem'}}>
                <li>Ga naar je relatie dashboard</li>
                <li>Klik <strong>"Download Rapport"</strong></li>
                <li>Kies <strong>"PDF Rapport"</strong></li>
                <li>Het rapport bevat:
                  <ul style={{marginTop: '0.5rem'}}>
                    <li>Gezins samenvatting</li>
                    <li>Scores per trede met uitleg</li>
                    <li>Individuele scores per deelenemer</li>
                    <li>Aanbevolen vervolgstappen</li>
                  </ul>
                </li>
              </ol>

              <h3 style={{color: '#1e3a8a', marginBottom: '1rem'}}>Rapport Delen</h3>
              <ul style={{color: '#64748b', lineHeight: '1.8'}}>
                <li>Je kunt het rapport delen met de gezinsleden</li>
                <li>Alle individuele antwoorden zijn zichtbaar voor de therapeut of coach</li>
                <li>Bespreek de resultaten in therapiesessie voor maximale impact</li>
              </ul>
            </div>

            {/* 5. Volgende Gezins Scans */}
            <div className="benefit-card" style={{marginBottom: '2rem'}}>
              <h2 className="card-title">5. Volgende GezinsScans</h2>
              
              <h3 style={{color: '#1e3a8a', marginBottom: '1rem'}}>Nieuwe Relaties</h3>
              <ul style={{color: '#64748b', lineHeight: '1.8', marginBottom: '1.5rem'}}>
                <li>Elk gezin heeft een eigen scan nodig</li>
                <li>Vraag extra scans aan via <strong>diederik@tractum.nl</strong></li>
                <li>Ideaal: 1-4 GezinsScans per jaar voor voortgang monitoring</li>
              </ul>

              <h3 style={{color: '#1e3a8a', marginBottom: '1rem'}}>Herhaalde Metingen</h3>
              <ul style={{color: '#64748b', lineHeight: '1.8'}}>
                <li>Herhaal de scan na 3-6 maanden</li>
                <li>Vergelijk voortgang over tijd</li>
                <li>Track verbetering na therapie-interventies</li>
              </ul>
            </div>

            {/* Contact */}
            <div className="benefit-card" style={{marginBottom: '2rem', borderLeft: '4px solid #ef4444'}}>
              <h2 className="card-title">Contact & Ondersteuning</h2>
              <p style={{color: '#64748b', marginBottom: '1rem'}}>
                <strong>Email:</strong> diederik@tractum.nl<br/>
                <strong>RelatieScan:</strong> <a href="https://gezinsscan.pabb.nl" style={{color: '#3b82f6'}}>https://relatiescan.pabb.nl</a>
              </p>
              
              <h3 style={{color: '#1e3a8a', marginBottom: '1rem'}}>Responstijden</h3>
              <ul style={{color: '#64748b', lineHeight: '1.8'}}>
                <li><strong>Technische problemen:</strong> Binnen 24 uur</li>
                <li><strong>Pakket aanvragen:</strong> 1-2 werkdagen</li>
                <li><strong>Algemene vragen:</strong> Binnen 48 uur</li>
              </ul>
            </div>

            {/* Navigation */}
            <div style={{textAlign: 'center', marginTop: '3rem'}}>
              <button 
                className="secondary-button" 
                onClick={goBack}
                style={{marginRight: '1rem'}}
              >
                ← Terug naar GezinsScan
              </button>
              </div>

          </div>
        </div>
      </section>
    </div>
  );
};

export default HandleidingTherapeut;